import { useEffect, useRef, useState } from 'react'
import "../../assets/css/server/server.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withRFSToken } from '../../Services/axios.js';
import { faBell, faPaperPlane, faSearch, faServer, faUser } from '@fortawesome/free-solid-svg-icons';
import { Link, useLocation } from 'react-router-dom';

const ServerPage = () => {
  const isMounted = useRef(false);
  const [allData, setAlldata] = useState(null);

  useEffect(() => {
    if (isMounted.current) return;
    fetchServerData();
    isMounted.current = true;
  }, []);

  const fetchServerData = async () => {
    try {
      const res = await withRFSToken.post("server-data")
        .then(function (res) {
          setAlldata(res.data.response_data);
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const handleBackAdmin = () => {
    const tokenValue = localStorage.getItem('ServerIWI');
        localStorage.setItem('airlinetoken', tokenValue);
        localStorage.removeItem('ServerIWI');
        window.location.replace('/Dashboard')
  }
  return (
    <div>

      <section className="header-main">
        <div className="container">
          {/* Header Start */}
          <div className="header-main-wrap">
            <div className="">
              <h2>Server Dashboard</h2>
              <span>Hi there, Great to see you again</span>
            </div>
            <div className="search-panel">
              <div className="search-div">
                <input
                  type="text"
                  className="form-control"
                  id=""
                  placeholder="Type here to search"
                />
                <div className="search-icon">
                   <FontAwesomeIcon icon={faSearch} />
                </div>
              </div>
              <div className="notification-div">
                <span>
                  <FontAwesomeIcon icon={faBell} />
                </span>
              </div>
              <div className="user-div">
                <span>
                 <FontAwesomeIcon icon={faUser} />
                </span>
              </div>
            </div>
          </div>
          <Link to='#' onClick={handleBackAdmin}>Back</Link>
          {/* Header End */}
          {/*box-div start */}
          <div className="box-sec">
            <div className="row justify-content-center">
              <div className="col-lg-3 col-md-6">
                <div className="box-div box-div-1">
                  <span>
                    <FontAwesomeIcon icon={faServer} />
                  </span>
                  <h3>
                    {allData?.failed_jobs + allData?.pending_jobs}
                  </h3>
                  <p>Job Count</p>

                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="box-div box-div-2">
                  <span>
                    <FontAwesomeIcon icon={faServer} />
                  </span>
                  <h3>
                    {allData?.failed_jobs}
                  </h3>
                  <p>Job failed</p>

                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="box-div box-div-3">
                  <span>
                    <FontAwesomeIcon icon={faServer} />
                  </span>
                  <h3>
                    {allData?.pending_jobs}
                  </h3>
                  <p>Job Pending</p>

                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="box-div box-div-4">
                  <span>
                    <FontAwesomeIcon icon={faServer} />
                  </span>
                  <h3>
                    3.07s
                  </h3>
                  <p>File Storage</p>

                </div>
              </div>
            </div>
          </div>
          {/*box-div end */}
          {/* notification div start  */}
          <div className="notice-sec">
            <div className="row">
              <div className="col-lg-9">
                <div className="chart-div">
                  <h2>Active Server</h2>
                  <div className="">
                    <div className="table-responsive custom-table">
                      <table className="table table-responsive table-bordered">
                        <thead>
                          <tr>
                            <th>Server Name</th>
                            <th>Server Status</th>
                            <th>Storage Total</th>
                            <th>Storage Use</th>
                            <th>Storage Remaining</th>
                          </tr>
                        </thead>
                        <tbody>
                          {allData?.server_data?.map((element, index) => (
                            <tr>
                              <td>
                                <span style={{ color: "#3e3ad3  " }}>
                                 {element?.name}
                                </span>
                              </td>
                              <td>
                                {(() => {
                                  const status = String(element?.status || "Unknown").toUpperCase();
                                  const statusStyles = {
                                    RUNNING: { bg: "#e6f7e6", color: "#2e7d32" },
                                    MAINTENANCE: { bg: "#fffbe6", color: "#bfa100" },
                                    DOWN: { bg: "#fedeee", color: "#af5166" },
                                    DEFAULT: { bg: "#fedeee", color: "#af5166" }
                                  };
                                  const { bg, color } = statusStyles[status] || statusStyles.DEFAULT;
                                  return (
                                    <span
                                      style={{
                                        background: bg,
                                        color: color,
                                        padding: "8px 15px",
                                        width: 100,
                                        textTransform: "uppercase",
                                        display: "inline-block",
                                        textAlign: "center",
                                        borderRadius: "4px"
                                      }}
                                      className="badge"
                                    >
                                      {status}
                                    </span>
                                  );
                                })()}
                              </td>
                              <td>{element?.total_storage}</td>
                              <td>{element?.used} ({element?.percentage})</td>
                              <td>{element?.remaning}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="chart-div">
                  <h2>Alert</h2>
                  <div className="notice-div">
                    <ul>
                      <li>
                        <div className="notice-img">
                          <h3>
                            Maleware Alert
                            <span>10:31:44 from Indonesia </span>
                            <span>WWW Server</span>
                          </h3>
                        </div>
                      </li>
                      <li>
                        <div className="notice-img">
                          <h3>
                            Phishing Alert
                            <span>10:31:44 from Indonesia</span>
                            <span>WWW Server</span>
                          </h3>
                        </div>
                      </li>
                      <li>
                        <div className="notice-img">
                          <h3>
                            Exploit Alert
                            <span>10:31:44 from Indonesia</span>
                            <span>WWW Server</span>
                          </h3>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* notification div end  */}
          {/* chart div start */}
          <div className="chart-sec">
            <div className="row">
              <div className="col-lg-8">
                <div className="chart-div">
                  <h2>Load Time - Last 24 hours</h2>
                  <div className="grah-img">
                    {/* <img src="assets/images/chart-1.png" alt="" /> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="chart-div">
                  <h2>Chart Remaining</h2>
                  <div className="pie-img">
                    {/* <img src="assets/images/pie.png" alt="" /> */}
                  </div>
                  <div className="error-div">
                    <ul>
                      <li>
                        <h4>
                          Error Name<span>3009</span>
                        </h4>
                      </li>
                      <li>
                        <h4>
                          Error Name<span>3009</span>
                        </h4>
                      </li>
                      <li>
                        <h4>
                          Error Name<span>3009</span>
                        </h4>
                      </li>
                      <li>
                        <h4>
                          Error Name<span>3009</span>
                        </h4>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* chart div end */}
        </div>
      </section>

    </div>
  )
}

export default ServerPage